@if(content && isVisible){

<div class="center w-12 p-t-2 p-b-2 height-100 flex flex-middle"
     [class]="(content.promobarColor || 'col-w') + ' ' + (content.promobarBackground || 'bg-col-6')">
    @if((content.promobarMessages?.length || 0) > 1){

    <carousel class="block w-12"
              [autoplay]="{
                delay: (content.promobarMessageDuration || 5) * 1000,
                disableOnInteraction: false
                }"
              [loop]="true"
              [allowTouchMove]="false"
              [speed]="1000"
              [fadeEffect]="{ crossFade: true }"
              [effect]="'fade'">
        @for (message of content.promobarMessages; track $index) {
        <ng-template carouselSlide>
            <ng-container [ngTemplateOutlet]="messageTmpl"
                          [ngTemplateOutletContext]="{$implicit: message}" />
        </ng-template>
        }
    </carousel>
    }@else if(content.promobarMessages?.length === 1){
    <ng-container [ngTemplateOutlet]="messageTmpl"
                  [ngTemplateOutletContext]="{$implicit: content.promobarMessages?.[0]}" />
    }
</div>
}

<ng-template #messageTmpl
             let-message>
    <href [link]="message?.link">
        <div class="wrap flex flex-middle flex-justify-center"
             [style.gap.px]="8">
            @if(!message?.isAdvanced){
            <div class="s1 inline-block underline"
                 *iCms="'copy' of message; content 'html'"></div>
            }@else{
            @for (block of message?.blocks; track $index) {
            @if(block.type === 'text'){
            <div class="s1 underline"
                 *iCms="'copy' of block; content 'html'"></div>
            }
            @else if(block.type === 'button'){
            <href [link]="block.link">
                <span class="s1"
                      [inlineButton]>
                    {{block.copy}}
                </span>
            </href>
            }@else {
            <page-header-promobar-countdown class="inline-block s1"
                                            [date]="countToDate" />
            }
            }
            }
        </div>
    </href>
</ng-template>